<template>
    <div class="sec-cont">
        <Head :title="__('Draft List')" />

        <DataTable :headers="tableHeaders" :data="tableData" @pdfDownload="pdfDownload">
            <template #default="{ rowIndex }">
                <div class="topics-list px-6 py-4">
                    <div
                        v-for="(draft, draftIndex) in all_schedulers[rowIndex].parsedDrafts"
                        :key="draftIndex"
                        class="draft-item mb-6 border p-4 rounded-lg"
                    >
                        <h3 class="font-bold">Topic: {{ draft.title }}</h3>
                        <div v-for="(topic, topicIndex) in draft.parsedTopics" :key="topicIndex" class="topic-item mb-4">
                            <div class="topic-header flex justify-between items-center">
                                <p><strong>Name: {{ topic.name }}</strong></p>
                                <button @click="toggleTopicExpand(rowIndex, draftIndex, topicIndex)">
                                    {{ expandedTopics[rowIndex]?.[draftIndex]?.includes(topicIndex) ? "Collapse Points" : "Expand Points" }}
                                </button>
                            </div>
                            <ul
                                v-if="expandedTopics[rowIndex]?.[draftIndex]?.includes(topicIndex)"
                                class="mt-2 pl-4 list-disc custom-list"
                            >
                                <li v-for="(point, pointIndex) in topic.points" :key="pointIndex">
                                    {{ point }}
                                </li>
                            </ul>
                        </div>
                        <!-- Show selected class for event at the end of each draft -->
                        <p class="font-bold mt-4">Class: {{ draft.selectedClassName || 'No Class Assigned' }}</p>
                    </div>
                </div>
            </template>
        </DataTable>
        <scheduler-details-print
            v-if="taskDetailsOpen"
            :isPopup="isPopup"
            :parsedDetails="selectedParsedDetails"
            :schedulerTitle=selectedSchedulerTitle
            @closeModal="taskDetailsOpen = false"
        />
    </div>
</template>

<script>
import { Head } from "@inertiajs/vue3";
import DataTable from "@/Shared/Component/DataTable.vue";
import Layout from '@/Shared/Layout';
import SchedulerDetailsPrint from '@/Shared/Modals/SchedulerDetailsPrint'

export default {
    components: {
        Head,
        DataTable,
        SchedulerDetailsPrint
    },
    layout: Layout,
    props: {
        all_schedulers: {
            required: true,
            type: Array,
        },
        isPopup: false,
    },
    data() {
        return {
            isPopup: false,
            selectedParsedDetails: [], // Store selected details here
            selectedSchedulerTitle: "", // Store selected details here
            taskDetailsOpen: false,
            taskDetailsId: null, // Add this to store selected ID
            tableHeaders: ["Title", "Event Type", "Date", "Toggle Details", "Action", "Download"],
            expandedTopics: {},
        };
    },
    computed: {
        isModalVisible() {
            return this.taskDetailsOpen;
        },
        tableData() {
            return this.all_schedulers.map((draft) => {
                console.log(draft.id)
                return [
                    { action:"edit", isLinkAction: true, label:draft.title, value: draft.id, path:"/admin/scheduler/"}, // Title
                    { value: draft.event_type }, // Event Type
                    {
                        value: draft.event_type === "day"
                            ? draft.single_date
                            : `${draft.from_date} - ${draft.to_date}`
                    }, // Date
                    { isAction: true, label: "Expand/Collapse Topics", action: "toggleExpand" },
                    { value:draft.id, isAction: true, label: "Update", action: "edit", path:"/admin/scheduler/"},
                    { value:draft.id, isAction: true, label: "View Details", action: "pdfDownload"},
                ];
            });
        }
    },
    mounted() {
        this.all_schedulers.forEach((draft) => {
            try {
                const parsedDetails = typeof draft.event_details === "string" ? JSON.parse(draft.event_details) : draft.event_details;

                if (Array.isArray(parsedDetails)) {
                    draft.parsedDrafts = parsedDetails.map((detail) => {
                        return detail.selectedDraft.map((selected) => {
                            return {
                                title: selected.title,
                                parsedTopics: typeof selected.topics === "string" ? JSON.parse(selected.topics) : selected.topics || [],
                                selectedClassName: detail.selectedClassForEvent
                                    ? detail.selectedClassForEvent.map(cls => cls.name).join(", ") // Joining multiple class names
                                    : "No Class Assigned"
                            };
                        });
                    }).flat();
                } else {
                    draft.parsedDrafts = [];
                }
            } catch (error) {
                console.error("Error parsing event_details:", error);
                draft.parsedDrafts = [];
            }
        });
    },
    methods: {
        openPdfModal(draftData) {
            this.selectedDrafts = draftData;
            this.taskDetailsOpen = true;
        },
        toggleTopicExpand(rowIndex, draftIndex, topicIndex) {
            if (!this.expandedTopics[rowIndex]) {
                this.expandedTopics[rowIndex] = {};
            }
            if (!this.expandedTopics[rowIndex][draftIndex]) {
                this.expandedTopics[rowIndex][draftIndex] = [];
            }

            const expanded = this.expandedTopics[rowIndex][draftIndex];

            if (expanded.includes(topicIndex)) {
                this.expandedTopics[rowIndex][draftIndex] = expanded.filter((i) => i !== topicIndex);
            } else {
                expanded.push(topicIndex);
            }
        },
        pdfDownload(id) {

            this.selectedParsedDetails = this.all_schedulers[id].parsedDrafts || [];
            this.selectedSchedulerTitle = this.all_schedulers[id].title
            this.isPopup = true
            this.taskDetailsOpen = true;
        },
    },
};
</script>
